<br>
<br>
<div class="password-page">
    <div class="container">
        <div class="create-information" *ngIf="!tokenVerificado" >
        <h1>Ingresa tu Código</h1>

        <form [formGroup]="formToken" (ngSubmit)="verificarToken()">
            <div class="form-group">
                <input type="text" class="form-control" placeholder="código" formControlName="token">
                <div class="alert alert-danger" role="alert" *ngIf="formToken.controls.token.errors &&
                                (formToken.controls.token.dirty || formToken.controls.token.touched)">
                                  <div *ngIf="formToken.controls.token.errors.required">La token es requerido.</div>
                              </div>
            </div>

            <div class="password-in">
                <div class="text-center">
                    <button type="submit" class="btn password-btn" [disabled]="!formToken.valid">Confirmar</button>
                </div>
                <div class="col-lg-12">
                    <div class="alert alert-danger" role="alert" *ngIf="mensajeErrorToken">
                        {{mensajeErrorToken}}
                    </div>
                </div>
            </div>
        </form>
        </div>
        <div *ngIf="tokenVerificado" >
            <div class="create-education create-education-two" id="verificar">
                <div class="create-education-wrap">
                    <div class="create-education-left">
                        <h3>Cambiar Contraseña</h3>
                    </div>
                </div>

                    <div class="alert alert-success" role="alert" *ngIf="mensajeExitoToken">
                        {{mensajeExitoToken}}
                    </div>
                <form [formGroup]="formPass" (ngSubmit)="actualizarContrasenia()">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                              <label>Nueva Contraseña</label>
                              <div class="tw-relative">
                                <input [type]="showNuevaPass ? 'text' : 'password'" formControlName="passNueva"
                                       placeholder="••••••••" minlength="8" required
                                       class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200
                                              tw-text-slate-900 tw-text-sm tw-outline-none
                                              focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                                              tw-transition tw-duration-150">
                                <button type="button" (click)="showNuevaPass = !showNuevaPass" tabindex="-1"
                                        class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
                                  <svg *ngIf="!showNuevaPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                  </svg>
                                  <svg *ngIf="showNuevaPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                                  </svg>
                                </button>
                              </div>
                              <div class="alert alert-danger" role="alert" *ngIf="formPass.controls.passNueva.errors && mostrarMensaje">
                                  <div *ngIf="formPass.controls.passNueva.errors.required">La contraseña nueva es requerido.</div>
                                  <div *ngIf="formPass.controls.passNueva.errors.minlength">La contraseña nueva debe contener al menos 8 carácteres.</div>
                              </div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="form-group">
                              <label>Confirmar Contraseña</label>
                              <div class="tw-relative">
                                <input [type]="showConfirmPass ? 'text' : 'password'" formControlName="passConfim"
                                       placeholder="••••••••" minlength="8" required
                                       class="tw-w-full tw-px-4 tw-py-2.5 tw-pr-10 tw-rounded-xl tw-border tw-border-slate-200
                                              tw-text-slate-900 tw-text-sm tw-outline-none
                                              focus:tw-ring-2 focus:tw-ring-blue-500/30 focus:tw-border-blue-500
                                              tw-transition tw-duration-150">
                                <button type="button" (click)="showConfirmPass = !showConfirmPass" tabindex="-1"
                                        class="tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-slate-400 hover:tw-text-slate-600 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer">
                                  <svg *ngIf="!showConfirmPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                  </svg>
                                  <svg *ngIf="showConfirmPass" class="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"/>
                                  </svg>
                                </button>
                              </div>
                              <div class="alert alert-danger" role="alert" *ngIf="formPass.controls.passConfim.errors && mostrarMensaje">
                                  <div *ngIf="formPass.controls.passConfim.errors.required">La contraseña de confirmación es requerido.</div>
                                  <div *ngIf="formPass.controls.passConfim.errors.minlength">La contraseña de confirmación debe contener al menos 8 carácteres.</div>
                              </div>
                            </div>
                        </div>

                        <div class="col-lg-12">
                            <div class="alert alert-success" role="alert" *ngIf="mensajeExito">
                                {{mensajeExito}}
                            </div>
                            <div class="alert alert-danger" role="alert" *ngIf="mensajeError">
                                {{mensajeError}}
                            </div>
                        </div>

                        <div class="text-left">
                            <button type="submit" class="btn create-ac-btn">Actualizar</button>
                        </div>
                      </div>
                </form>
            </div>
        </div>
    </div>
</div>

